import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

import { AppState } from 'services/types';

// Components
import LogoutButton from '../../../../components/LogoutButton';
import OrganizationsListItem from './components/OrganizationsListItem';

// Selectors
import { selectActiveIds } from './selectors';

interface Props {
    ids?: string[];
}

export class OrganizationsList extends React.PureComponent<Props> {
    render(): React.ReactElement[] | React.ReactElement {
        const { ids } = this.props;

        if (!ids || !ids.length) {
            return (
                <Message warning>
                    Sorry, you don&apos;t have permission to view any
                    Organizations.
                    <LogoutButton />
                </Message>
            );
        }

        return ids.map((id) => (
            <OrganizationsListItem key={id} organizationId={id} />
        ));
    }
}

const mapStateToProps = createStructuredSelector<AppState, Props>({
    ids: selectActiveIds
});

export default connect(mapStateToProps)(OrganizationsList);
